var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTransactionsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6017_9038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 2C6.60207 2 2.12207 6.48 2.12207 12C2.12207 17.52 6.60207 22 12.1221 22C17.6421 22 22.1221 17.52 22.1221 12C22.1221 6.48 17.6421 2 12.1221 2ZM12.1221 20C7.71207 20 4.12207 16.41 4.12207 12C4.12207 7.59 7.71207 4 12.1221 4C16.5321 4 20.1221 7.59 20.1221 12C20.1221 16.41 16.5321 20 12.1221 20ZM12.4321 11.14C10.6621 10.69 10.0921 10.2 10.0921 9.47C10.0921 8.63 10.8821 8.04 12.1921 8.04C13.5721 8.04 14.0921 8.7 14.1321 9.68H15.8421C15.7921 8.34 14.9721 7.11 13.3521 6.71V5H11.0221V6.69C9.51207 7.01 8.30207 7.99 8.30207 9.5C8.30207 11.29 9.79207 12.19 11.9621 12.71C13.9121 13.17 14.3021 13.86 14.3021 14.58C14.3021 15.11 13.9121 15.97 12.2021 15.97C10.6021 15.97 9.97207 15.25 9.88207 14.33H8.16207C8.26207 16.03 9.52207 16.99 11.0221 17.3V19H13.3621V17.33C14.8821 17.04 16.0821 16.17 16.0921 14.56C16.0821 12.36 14.1921 11.6 12.4321 11.14Z",
    fill: "#79767D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6017_9038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.12207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionsInactive);
export default __webpack_public_path__ + "static/media/ic_transactions-inactive.be3e259cfc43583baf8830bb3157e4b4.svg";
export { ForwardRef as ReactComponent };